import { useMemo } from 'react';

import { MessageInterface, PromptTurn } from '@type/chat';
import { derivePromptTurns } from '@utils/chatNavigation';

export const usePromptTurns = (messages: MessageInterface[]): PromptTurn[] => {
  return useMemo(() => derivePromptTurns(messages), [messages]);
};